import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { parse } from "date-fns";
import moment from "moment";
import { BaseComponent } from "BaseComponent";
import reactCSS from "reactcss";
import Select from "react-select";

// constants
import { showError, showSuccess } from "ReduxErrorBar";
import { maxLengthObjectFc } from "Constants";
import LocaleStrings from "Languages";

// actions
import {
  handleBulkEditModal,
  handleBulkEditUpdate,
  fetchAndRefreshScheduleData,
  createBulkTracks,
} from "ContentActions";

// components
// files
const DeletTrashIcon = "../../style/images/delete.png";

const NO_TRACK = "##NOTRACK##";
const NO_TRACK_ITEM = {
  label: "No Track",
  value: "notrack",
  __isNew__: true,
};
const ScheduleItem = {
  title: null,
  description: null,
  location: null,
  liveurl: null,
  session_type: "general",

  starttime: moment(),
  endtime: moment(),
  validtime: false,

  // date
  dateid: null, // schedule date id
  date: null, // formatted date string

  // track
  track: null, // track id
  trackname: null, // track name
  allow_track_select: true,

  // color
  colorid: null, // color id
  session_color: "#ffffff", // default colour hex value

  // speaker
  speakerid: null, // primary speaker, 0th index
  speaker: [], // detail objs
  speakers: "", // comma separated speaker ids
  speaker_str: "", // comma separated speaker names

  // checkin
  checkin_type: "", // type value
  checkin_type_text: "", // type name
  checkin_opt: null,

  // eventtags
  event_tags: "", // comma separated interest id from DB
  event_tags_str: "", // tag name str

  // rsvp and capacity
  rsvp: false,
  rsvp_text: LocaleStrings.button_no,
  allow_capacity: true,
  capacity: 0,
  capacity_text: LocaleStrings.unlimited,
};
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
var MAXLENOBJ = {};

class ScheduleBulkEdit extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitButtonLoading: false,
      local_schedules: [], // this holds only the date-track master details/options to render accordingly
      displayColorPicker: { itemIndex: null, state: false },
      userInterest: [],
      workingScheduleData: [], // mutable state data holder
      renderInput: { name: "", index: "" }, // Which cell index span to be replaced with field element
      data_updated: {
        status: false,
        name: "",
        index: "",
        invalidDate: false,
        errorCells: [],
      }, // Custom flag to determine if data updated and if any invalid time is present
      updated_schedule_list: [], // This list holds the array indexes for schedules to be updated, making update resource limited. All the ids' are uniqly stored.
    };
  }

  componentDidMount() {
    this.setState({
      workingScheduleData: this.props.Schedules,
    });

    // ----- Selected date wise track managing (holds master data)
    let _localSchedules = [];
    _.map(this.props.Schedules, (schedule, index) => {
      _localSchedules[index] = {
        dateOptons: this.props.ScheduleDates,
      };

      let filterTracks = _.filter(
        this.props.ScheduleDates,
        (date) => date.id === schedule.dateid
      );

      if (filterTracks.length) {
        _localSchedules[index].trackOptions = filterTracks[0].tracks;
        _localSchedules[index].schedule_date = filterTracks[0].scheduledate;
      } else {
        _localSchedules[index].trackOptions = [NO_TRACK_ITEM];
        // _localSchedules[index].schedule_date = filterTracks[0].scheduledate;
      }
    });
    this.setState({ local_schedules: _localSchedules });

    // ----- Max length obj set
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
  }

  closeModal = () => {
    !this.state.isSubmitButtonLoading &&
      this.props.handleBulkEditModal({ show: false });
  };

  // --- Form submit handler
  onSubmitHandler = () => {
    let local_workingScheduleData = [],
      _sessionSpeakerData = { deleteFor: [], createArr: [] },
      _tracksToCreate = {},
      state_localSchedules = this.state.local_schedules;

    // this.setState({ isSubmitButtonLoading: true });

    _.map(this.state.workingScheduleData, (schedule, scheduleKey) => {
      if (_.includes(this.state.updated_schedule_list, scheduleKey)) {
        // --- New track identifying
        if (_.includes(schedule.track, "new_")) {
          // - Gettting new tracks details from state local_schedule array, finding with id 'new_<number>'
          let _trackData = _.find(
            state_localSchedules[scheduleKey].trackOptions,
            (item) => item.id === schedule.track
          );

          // - Assigning update object with 'new_<number>' key
          _tracksToCreate[schedule.track] = {
            eventid: this.props.session.eventid,
            scheduledateid: schedule.dateid,
            trackname: _trackData.trackname,
          };
        }

        // --- Schedule update resource obj
        // - Obj create
        let local_schedule = {
          eventid: this.props.session.eventid,
          // sessionid: schedule.id,
          title: schedule.title,
          starttime: schedule.starttime.format("yyyy-MM-DD HH:mm:ss"),
          endtime: schedule.endtime.format("yyyy-MM-DD HH:mm:ss"),
          description: schedule.description,
          location: schedule.location,
          videolink: schedule.liveurl,
          sessiontype: schedule.session_type,
          scheduletrackid: schedule.track, // with possible new track id
          colorid: schedule.colorid,
          speakerid: schedule.speakerid,
          checkintype: schedule.checkin_type,
          tags: schedule.event_tags,
          rsvp: schedule.rsvp,
          capacity: schedule.capacity,
        };

        if (schedule.id != null) local_schedule.sessionid = schedule.id; // Will help to determine new inserts

        // - Obj pushed | Moved below for new insert case
        // local_workingScheduleData.push(local_schedule);

        // --- SessionSpeaker section
        if (schedule.id != null) {
          // - Update determination
          let shouldUpdate = _.filter(
            schedule.speaker,
            (speaker) => speaker.id
          );

          if (
            this.props.Schedules[scheduleKey].speaker.length !=
              schedule.speaker.length ||
            (shouldUpdate.length &&
              shouldUpdate.length != schedule.speaker.length)
          ) {
            // - Delete for determination
            _sessionSpeakerData.deleteFor.push(schedule.id);

            // - Create section
            schedule.speaker.length &&
              _.map(schedule.speaker, (speaker, speakerKey) => {
                if (speakerKey > 0) {
                  let local_speaker_obj = {
                    eventid: this.props.session.eventid,
                    speakerid: speaker.value, // though id's there but value will definately come
                    sessionid: schedule.id,
                  };

                  _sessionSpeakerData.createArr.push(local_speaker_obj);
                }
              });
          }
        } else if (schedule.speaker.length) {
          // - Create section for new inserts

          // NOTE: Instead of separate arrays and batch update, using DF relations and insert payload structure
          // SOURCE: https://wiki.dreamfactory.com/DreamFactory/Features/Database/Related_Data

          // Relation field
          local_schedule.sessionspeakers_by_sessionid = [];

          _.map(schedule.speaker, (speaker, speakerKey) => {
            if (speakerKey > 0) {
              let local_speaker_obj = {
                eventid: this.props.session.eventid,
                speakerid: speaker.value, // though id's there but value will definately come
              };

              // Assigning to schedule's related field
              local_schedule.sessionspeakers_by_sessionid.push(
                local_speaker_obj
              );
            }
          });
        }

        // - Session object pushed
        local_workingScheduleData.push(local_schedule);
      }
    });

    // --- Creating new tracks if needed
    if (!_.isEmpty(_tracksToCreate)) {
      this.props.createBulkTracks(
        this.props.session,
        _tracksToCreate,
        (res) => {
          if (!res.success) {
            this.setState({ isSubmitButtonLoading: false });
            this.props.showError(
              LocaleStrings.schedule_modal_bulkedit_success_00
            );
          } else {
            this.props.showSuccess(
              LocaleStrings.schedule_modal_bulkedit_success_track
            );

            // --- Assigning new obtained track ids to session payload and schedule payload separation
            let _toUpdate = [],
              _toCreate = [];

            _.map(local_workingScheduleData, (schedule, scheduleKey) => {
              if (_.includes(schedule.scheduletrackid, "new_")) {
                schedule.scheduletrackid =
                  res.data[schedule.scheduletrackid].scheduletrackid;
              }

              // --- Separating schedules for update/create
              if (schedule.sessionid == null) _toCreate.push(schedule);
              else _toUpdate.push(schedule);
            });

            // --- Bulk payload object with possible new track ids assigned
            let actionValue = {
              session_update_resource: _toUpdate,
              session_create_resource: _toCreate,
              speakerDelete: _sessionSpeakerData.deleteFor.join(","), // comma separated ids to filter
              speakerCreate: _sessionSpeakerData.createArr,
            };

            this.props.handleBulkEditUpdate(
              this.props.session,
              actionValue,
              (res) => {
                this.setState({ isSubmitButtonLoading: false });

                let call_refresh = true,
                  closeModal = true;

                switch (res.case) {
                  case "update":
                    if (res.success)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_1
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_success_00
                      );
                      call_refresh = false;
                    }
                    break;

                  case "update-speaker_delete":
                    if (res.sessionspeaker_success)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_11
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_success_10
                      );
                      closeModal = false;
                    }
                    break;

                  case "update-speaker_delete-create":
                    if (res.session_create)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_11_create
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_error_11_create
                      );
                      closeModal = false;
                    }
                    break;

                  case "update-speaker_insert":
                    if (res.sessionspeaker_success)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_11
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_success_10
                      );
                      closeModal = false;
                    }
                    break;

                  case "update-speaker_insert-create":
                    if (res.session_create)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_11_create
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_error_11_create
                      );
                      closeModal = false;
                    }
                    break;

                  case "create":
                    if (res.session_create)
                      this.props.showSuccess(
                        LocaleStrings.schedule_modal_bulkedit_success_create
                      );
                    else {
                      this.props.showError(
                        LocaleStrings.schedule_modal_bulkedit_error_create
                      );
                      closeModal = false;
                    }
                    break;

                  default:
                    break;
                }

                if (call_refresh) {
                  // --- List refresh call
                  this.props.fetchAndRefreshScheduleData(
                    this.props.session,
                    this.props.selectedScheduleDate.scheduledateid
                  );
                }

                if (closeModal) {
                  setTimeout(() => {
                    this.closeModal();
                  }, 1000);
                }

                // if (res.success) {
                //   this.props.fetchAndRefreshScheduleData(
                //     this.props.session,
                //     this.props.selectedScheduleDate.scheduledateid
                //   );

                //   if (!res.sessionspeaker_success)
                //     // speaker update has failed (either DELETE/UPDATE, check res.case)
                //     this.props.showError(
                //       LocaleStrings.schedule_modal_bulkedit_success_10
                //     );
                //   else if (res.sessionspeaker_success === 2) {
                //     // session updated, nothing to update for speaker
                //     this.props.showSuccess(
                //       LocaleStrings.schedule_modal_bulkedit_success_1
                //     );

                //     setTimeout(() => {
                //       this.closeModal();
                //     }, 1000);
                //   } else {
                //     // session and speaker both updated
                //     this.props.showSuccess(
                //       LocaleStrings.schedule_modal_bulkedit_success_11
                //     );

                //     setTimeout(() => {
                //       this.closeModal();
                //     }, 1000);
                //   }
                // } else {
                //   // nothing updated
                //   this.props.showError(
                //     LocaleStrings.schedule_modal_bulkedit_success_00
                //   );
                // }
              }
            );
          }
        }
      );
    } else {
      // --- Separating schedules for update/create
      let _toUpdate = [],
        _toCreate = [];
      _.map(local_workingScheduleData, (schedule, scheduleKey) => {
        if (schedule.sessionid == null) _toCreate.push(schedule);
        else _toUpdate.push(schedule);
      });

      // --- Bulk payload object with possible new track ids assigned
      let actionValue = {
        session_update_resource: _toUpdate,
        session_create_resource: _toCreate,
        speakerDelete: _sessionSpeakerData.deleteFor.join(","), // comma separated ids to filter
        speakerCreate: _sessionSpeakerData.createArr,
      };

      this.props.handleBulkEditUpdate(
        this.props.session,
        actionValue,
        (res) => {
          this.setState({ isSubmitButtonLoading: false });

          let call_refresh = true,
            closeModal = true;

          switch (res.case) {
            case "update":
              if (res.success)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_1
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_success_00
                );
                call_refresh = false;
              }
              break;

            case "update-speaker_delete":
              if (res.sessionspeaker_success)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_11
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_success_10
                );
                closeModal = false;
              }
              break;

            case "update-speaker_delete-create":
              if (res.session_create)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_11_create
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_error_11_create
                );
                closeModal = false;
              }
              break;

            case "update-speaker_insert":
              if (res.sessionspeaker_success)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_11
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_success_10
                );
                closeModal = false;
              }
              break;

            case "update-speaker_insert-create":
              if (res.session_create)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_11_create
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_error_11_create
                );
                closeModal = false;
              }
              break;

            case "create":
              if (res.session_create)
                this.props.showSuccess(
                  LocaleStrings.schedule_modal_bulkedit_success_create
                );
              else {
                this.props.showError(
                  LocaleStrings.schedule_modal_bulkedit_error_create
                );
                closeModal = false;
              }
              break;

            default:
              break;
          }

          if (call_refresh) {
            // --- List refresh call
            this.props.fetchAndRefreshScheduleData(
              this.props.session,
              this.props.selectedScheduleDate.scheduledateid
            );
          }

          if (closeModal) {
            setTimeout(() => {
              this.closeModal();
            }, 1000);
          }
        }
      );
    }
  };

  // --- Add/remove no track for selected date
  handleTrackForDate = ({ type, dateId }) => {
    switch (type) {
      case "add":
        break;

      case "remove":
        break;

      default:
        break;
    }
  };

  // ===== New session starts =====
  addNewSessionBlankRow = () => {
    let _workingData = this.state.workingScheduleData,
      _localSchedules = this.state.local_schedules,
      newScheduleItem = JSON.parse(JSON.stringify(ScheduleItem)),
      _dataUpdated = this.state.data_updated; // Deep cloning

    // --- Setting some default values
    // - date
    newScheduleItem.date = this.props.ScheduleDates[0].date;
    newScheduleItem.dateid = _.toInteger(this.props.ScheduleDates[0].id);
    // - Times
    newScheduleItem.starttime = moment(
      `${this.props.ScheduleDates[0].scheduledate} 00:00:00`
    );
    newScheduleItem.endtime = moment(
      `${this.props.ScheduleDates[0].scheduledate} 00:00:00`
    );

    // - Checkins
    newScheduleItem.checkin_type = this.props.checkinType[0].value; // type value
    newScheduleItem.checkin_type_text = this.props.checkinType[0].name; // type name
    newScheduleItem.checkin_opt = this.props.checkinType;
    // - color
    newScheduleItem.colorid = this.props.SessionColors[0].colorid;
    newScheduleItem.session_color = this.props.SessionColors[0].backgroundcolor;

    _workingData.push(newScheduleItem);

    // --- Date and track options (state.local_schedule) management
    _localSchedules.push({
      dateOptons: this.props.ScheduleDates,
      trackOptions: this.state.local_schedules[0].trackOptions,
      schedule_date: this.props.ScheduleDates[0].scheduledate,
    });

    // --- Will disable the submit button as data needs to be filled (track may be, title, time)
    // If trackname is  blank other than NOTRACK date
    if (
      this.props.ScheduleDates[0].tracks.length &&
      this.props.ScheduleDates[0].tracks[0].trackname !== NO_TRACK
    )
      _dataUpdated.errorCells.push({
        index: this.state.workingScheduleData.length - 1,
        name: "track",
      });
    // title and times needs to be updated for any case
    _dataUpdated.errorCells.push(
      { index: this.state.workingScheduleData.length - 1, name: "title" },
      { index: this.state.workingScheduleData.length - 1, name: "time" }
    );

    this.setState({
      workingScheduleData: _workingData,
      local_schedules: _localSchedules,
      data_updated: _dataUpdated,
    });

    const newRowElement = document.getElementById("theBottomOfTheTable");
    newRowElement.scrollIntoView({
      behaviour: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  handleDeleteNewRow = (index) =>
    this.setState({
      workingScheduleData: this.state.workingScheduleData.filter(
        (s, i) => i != index
      ),
      data_updated: {
        ...this.state.data_updated,
        errorCells: this.state.data_updated.errorCells.filter(
          (d, i) => d.index != index
        ),
      },
    });
  // =====  New session ends  =====

  // ===== onChange handlers start ======
  // ----- Cell selection/clearing functions
  handleCellSelection = (index, name) => {
    const { renderInput, workingScheduleData } = this.state;

    // --- This will restrict other cell selection locally w/o redux-form. Maintain error message accordingly (not below cell, affects UI)
    // if (
    //   (renderInput.name === "title" &&
    //     _.isEmpty(workingScheduleData[renderInput.index].title)) || // ------ title can not be empty
    //   ((renderInput.name === "starttime" || renderInput.name === "endtime") &&
    //     !workingScheduleData[renderInput.index].validtime) // ------------------ time different has to be valid (startime < endtime)
    // ) {
    //   // DO NOTHING | Render error message
    // } else
    this.setState({ renderInput: { name, index } }); // Cell selection
  };

  // ----- common onChange handler -----
  onChangeManager = (e, index, data1) => {
    const { ScheduleDates, checkinType, SessionColors } = this.props,
      { local_schedules, workingScheduleData } = this.state;

    // --- Common variables
    let fieldName = _.split(e.target.name, ".").pop(),
      _workingData = workingScheduleData,
      _localSchedules = local_schedules,
      filterTracks = [];

    // --- Field wise data assigning
    switch (fieldName) {
      case "dateid":
        let _localSchedule = local_schedules;
        // --- localSchedule update
        filterTracks = _.filter(
          ScheduleDates,
          (date) => date.id == e.target.value
        );
        _localSchedule[index].trackOptions = filterTracks[0].tracks;
        _localSchedule[index].schedule_date = filterTracks[0].scheduledate;
        this.setState({ local_schedules: _localSchedule });

        // --- workingData update
        // - date update
        _workingData[index].date = filterTracks[0].date;
        _workingData[index].dateid = _.toInteger(e.target.value);
        // - date wise track select, default 0th
        _workingData[index].trackname = filterTracks[0].tracks.length // If no track is created for the selected date
          ? filterTracks[0].tracks[0].trackname
          : // === "##NOTRACK##"
            // ? ""
            // : filterTracks[0].tracks[0].trackname
            "";
        _workingData[index].track = filterTracks[0].tracks.length
          ? filterTracks[0].tracks[0].id
          : []; // If no track is there
        _workingData[index].allow_track_select =
          filterTracks[0].tracks.length &&
          filterTracks[0].tracks[0].trackname === "##NOTRACK##"
            ? false
            : true;

        // New schedule item get's 1st date's starttime-endtime, so once date is changed assigning selected date's starttime-endtime
        if (_workingData[index].id == null) {
          _workingData[index].starttime = moment(
            `${filterTracks[0].scheduledate} 00:00:00`
          );
          _workingData[index].endtime = moment(
            `${filterTracks[0].scheduledate} 00:00:00`
          );
        }
        break;

      case "track":
        // --- New track got created / have to assign new track
        if (data1?.__isNew__) {
          // - Working data updated
          _workingData[index].trackname = data1.label;

          // - Creating this new track locally
          if (data1.id == null) {
            // If it's new the obj will be {label: '', value: '', __isNew__: true}
            let trackId = `new_${local_schedules[index].trackOptions.length}`;

            _localSchedules[index].trackOptions.push({
              ...local_schedules[index].trackOptions[0],
              ...data1,
              id: trackId,
              name: data1.label,
              trackname: data1.label,
            });
            _workingData[index].track = trackId;
          } else {
            // new track is locally created
            _workingData[index].track = data1.id;
          }
        } else if (!_.isEmpty(data1)) {
          _workingData[index].track = _.toInteger(data1.value);
          _workingData[index].trackname = data1.trackname;
        } // else it'll get validated

        break;

      case "title":
        _workingData[index].title = e.target.value.trim();
        break;

      case "location":
        _workingData[index].location =
          e.target.value.trim() == "" ? null : e.target.value;
        break;

      case "starttime":
        _workingData[index].starttime = data1;
        break;

      case "endtime":
        _workingData[index].endtime = data1;
        break;

      case "description":
        _workingData[index].description =
          e.target.value.trim() == "" ? null : e.target.value;
        break;

      case "speakers":
        if (!_.isEmpty(data1)) {
          let nameArr = [],
            idArr = [];
          _.map(data1, (speaker) => {
            nameArr.push(speaker.name);
            idArr.push(speaker.value);
          });

          _workingData[index] = {
            ..._workingData[index],
            speakerid: data1[0].value, // primary speaker id set
            speaker: data1, // speaker details set
            speakers: _.join(idArr, ","), // id arr set
            speaker_str: _.join(nameArr, ", "), // name arr set
          };
        } else {
          _workingData[index] = {
            ..._workingData[index],
            speakerid: null,
            speaker: null,
            speakers: "",
            speaker_str: "",
          };
        }
        break;

      case "checkin_type":
        _workingData[index].checkin_type = e.target.value;

        let filterCheckin = _.filter(
          checkinType,
          (type) => type.value == e.target.value
        );

        _workingData[index].checkin_type_text = filterCheckin[0].name;
        break;

      case "session_color":
        _workingData[index].session_color = data1.hex.toUpperCase();

        let filteredColorData = _.filter(
          SessionColors,
          (color) => color.backgroundcolor == data1.hex.toUpperCase()
        );
        if (filteredColorData.length)
          _workingData[index].colorid = filteredColorData[0].colorid;
        break;

      case "event_tags":
        if (!_.isEmpty(data1)) {
          let nameArr = [],
            idArr = [];
          _.map(data1, (tag) => {
            nameArr.push(tag.name);
            idArr.push(tag.value);
          });

          _workingData[index] = {
            ..._workingData[index],
            event_tags: _.join(idArr, ","), // id arr set
            event_tags_str: _.join(nameArr, ", "), // name arr set
          };
        } else {
          _workingData[index] = {
            ..._workingData[index],
            event_tags: "",
            event_tags_str: "",
          };
        }
        break;

      case "session_type":
        _workingData[index].session_type = e.target.value;
        break;

      case "liveurl":
        _workingData[index].liveurl =
          e.target.value.trim() == "" ? null : e.target.value;
        break;

      case "rsvp":
        _workingData[index].rsvp = e.target.checked;
        _workingData[index].rsvp_text = e.target.checked
          ? LocaleStrings.button_yes
          : LocaleStrings.button_no;
        _workingData[index].allow_capacity = e.target.checked;

        // handling capacity
        if (!e.target.checked) {
          _workingData[index].capacity = 0;
          _workingData[index].capacity_text = LocaleStrings.unlimited;
        }
        break;

      case "capacity":
        _workingData[index].capacity = e.target.value;
        _workingData[index].capacity_text =
          _workingData[index].rsvp && e.target.value > 0
            ? e.target.value
            : LocaleStrings.unlimited;
        break;

      default:
        break;
    }

    // --- Validation maintainer
    this.handleValidation({ index, fieldName, _workingData });
  };

  // ----- Color picker starts -----
  handlePickerClickOpen = (index) => {
    let local_picker_obj = {
      itemIndex:
        index === this.state.displayColorPicker.itemIndex ? null : index,
      state:
        index === this.state.displayColorPicker.itemIndex
          ? false
          : !this.state.displayColorPicker.state,
    };

    this.setState({
      displayColorPicker: local_picker_obj,
    });
  };
  handlePickerClickClose = () => {
    this.setState({ displayColorPicker: { itemIndex: null, state: false } });
  };
  // -----  Color picker ends  -----

  handleValidation = ({ index, fieldName, _workingData }) => {
    const { Schedules } = this.props,
      { data_updated, updated_schedule_list } = this.state;

    let _dataUpdated = false,
      local_dataUpdateObj = data_updated,
      timeError = false,
      isNewInsert = false;

    if (_workingData[index].id == null) isNewInsert = true;

    // --- Checking schedule start and end time
    if (_workingData[index].endtime.diff(_workingData[index].starttime) <= 0) {
      _workingData[index].validtime = false;
      timeError = true;
    } else {
      _workingData[index].validtime = true;
    }

    // --- Checking if form data has updated
    // - Checks if field data has updated
    if (isNewInsert) {
      if (_workingData[index].title !== "" && _workingData[index].validtime) {
        _dataUpdated = true;
      }
    } else if (
      _workingData[index].title !== "" && // ------------------- if title not empty
      (Schedules[index][`${fieldName}`] !==
        _workingData[index][`${fieldName}`] ||
        ((fieldName === "starttime" || fieldName === "endtime") &&
          !Schedules[index][`${fieldName}`].diff(
            _workingData[index][`${fieldName}`]
          ) !== 0)) && // -------------------------------------- original data is not same as updated current data
      _workingData[index].validtime // ------------------------- schedule has valid date
    )
      _dataUpdated = true;

    // - Checks if form data has previously updated
    if (
      data_updated.status &&
      data_updated.index === index &&
      data_updated.name === fieldName &&
      !_dataUpdated
    )
      local_dataUpdateObj = {
        ...local_dataUpdateObj,
        status: false,
        name: "",
        index: "",
      };
    else if ((!data_updated.status && _dataUpdated) || isNewInsert)
      local_dataUpdateObj = {
        ...local_dataUpdateObj,
        status: true,
        name: fieldName,
        index,
      };

    // --- Identifying the schedules to update
    let updatedSchedules = updated_schedule_list; // previously updated schedule indexes
    _dataUpdated && updatedSchedules.push(index);
    updatedSchedules = _.uniq(updatedSchedules); // making the list uniq

    // --- Required fields error handling
    // - track
    if (_.isEmpty(_workingData[index].trackname)) {
      let _trackErrorExists = _.find(local_dataUpdateObj.errorCells, {
        index,
        name: "track",
      });

      if (_trackErrorExists == null)
        local_dataUpdateObj.errorCells.push({ index, name: "track" });
    } else if (local_dataUpdateObj.errorCells.length)
      _.remove(
        local_dataUpdateObj.errorCells,
        (error) => error.index === index && error.name === "track"
      );
    // - title
    if (_.isEmpty(_workingData[index].title)) {
      let _titleErrorExists = _.find(local_dataUpdateObj.errorCells, {
        index,
        name: "title",
      });

      if (_titleErrorExists == null)
        local_dataUpdateObj.errorCells.push({ index, name: "title" });
    } else if (local_dataUpdateObj.errorCells.length)
      _.remove(
        local_dataUpdateObj.errorCells,
        (error) => error.index === index && error.name === "title"
      );
    // - time
    if (_workingData[index].validtime === false || timeError) {
      let _timeErrorExists = _.find(local_dataUpdateObj.errorCells, {
        index,
        name: "time",
      });

      if (_timeErrorExists == null)
        local_dataUpdateObj.errorCells.push({ index, name: "time" });
    } else if (local_dataUpdateObj.errorCells.length) {
      _.remove(
        local_dataUpdateObj.errorCells,
        (error) => error.index === index && error.name === "time"
      );
    }

    // --- working data & state update
    this.setState({
      workingScheduleData: _workingData,
      updated_schedule_list: updatedSchedules,
      data_updated: local_dataUpdateObj,
    });
  };
  // =====  onChange handlers end  ======

  render() {
    const { bulkEditModal, handleSubmit } = this.props,
      { isSubmitButtonLoading, data_updated } = this.state;

    const tableHeaders = (
      <tr className="header-row">
        <th className="serial border-none first-cell">
          <div></div>
        </th>
        <th className="header date">
          <div className="center">
            {
              LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_date
            }
          </div>
        </th>
        <th className="header track">
          <div className="center">
            {LocaleStrings.analytics_sessions_table_thead_text10}
          </div>
        </th>
        <th className="header title">
          <div className="center">
            {LocaleStrings.schedule_form_label_title}
            <span className="label-mandatory">*</span>
          </div>
        </th>
        <th className="header location">
          <div className="center">{LocaleStrings.schedule_label_location}</div>
        </th>
        <th className="header time">
          <div className="center">
            {LocaleStrings.schedule_label_starttime}
            <span className="label-mandatory">*</span>
          </div>
        </th>
        <th className="header time">
          <div className="center">
            {LocaleStrings.schedule_label_endtime}
            <span className="label-mandatory">*</span>
          </div>
        </th>
        <th className="header desc">
          <div className="center">
            {LocaleStrings.schedule_form_label_description}
          </div>
        </th>
        <th className="header speakers">
          <div className="center">
            {LocaleStrings.schedule_form_label_speaker}
          </div>
        </th>
        <th className="header checkin">
          <div className="center">
            {LocaleStrings.schedule_form_label_checkintype}
          </div>
        </th>
        <th className="header sessioncolor">
          <div className="center">
            {LocaleStrings.schedule_form_label_color}
          </div>
        </th>
        <th className="header eventtags">
          <div className="center">{LocaleStrings.schedule_form_label_tags}</div>
        </th>
        <th className="header sessiontype">
          <div className="center">
            {LocaleStrings.schedule_form_label_session_type}
          </div>
        </th>
        <th className="header rsvp">
          <div className="center">{LocaleStrings.rsvp}</div>
        </th>
        <th className="header capacity">
          <div className="center">
            {LocaleStrings.schedule_form_label_capacity}
          </div>
        </th>
        <th className="header liveurl">
          <div className="center">
            {LocaleStrings.schedule_form_label_main_video}
          </div>
        </th>
      </tr>
    );

    return (
      <>
        <Modal
          className="modal-container"
          show={!_.isEmpty(bulkEditModal) && bulkEditModal.show}
          onHide={this.closeModal}
          animation={true}
          dialogClassName={"xl"} // much data "xl" : "lg"
          size={"xl"}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.schedule_modal_bulkedit_title}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
                alt={"close this modal"}
              />
            </button>
          </Modal.Header>

          <form onSubmit={handleSubmit(this.onSubmitHandler)}>
            <Modal.Body>
              {/* --- Add new session button --- */}
              <div className="schedule-bulk-edit-upper-section mb-2">
                <Button
                  className="btn btn-custom-blue"
                  type="button"
                  onClick={this.addNewSessionBlankRow}
                  style={{
                    display: "flex",
                    gap: 4,
                    alignItems: "center",
                  }}
                >
                  <img
                    src="../../style/images/header-icons/plus.png"
                    alt="add new sessions"
                  />
                  <div className="">{LocaleStrings.button_new_session}</div>
                </Button>
              </div>

              {/* --- Data table --- */}
              <div className="schedule-bulk-edit-container">
                <div className="">
                  <table className="schedule-bulk-edit-table table">
                    <thead>{tableHeaders}</thead>
                    <tbody>
                      <BasicTableBody
                        {...this.props}
                        {...this.state}
                        onChangeManager={this.onChangeManager}
                        handlePickerClickOpen={this.handlePickerClickOpen}
                        handlePickerClickClose={this.handlePickerClickClose}
                        handleCellSelection={this.handleCellSelection}
                        handleDeleteNewRow={this.handleDeleteNewRow}
                      />
                    </tbody>
                  </table>

                  {/* --- Bottom of the table --- */}
                  <div
                    id="theBottomOfTheTable"
                    style={{ marginTop: "6rem" }}
                  ></div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                bsStyle=""
                className="btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                bsStyle=""
                className="btn btn-custom-blue ml-10"
                loading={isSubmitButtonLoading}
                type="submit"
                disabled={
                  !data_updated.status ||
                  data_updated.errorCells.length ||
                  isSubmitButtonLoading
                }
              >
                {LocaleStrings.button_close_and_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  let SessionColorsReducer = state.sessionColors,
    ScheduleDataReducer = state.scheduleData,
    InterestsReducer = state.interests;

  let SessionColors = [],
    ScheduleDates = [],
    DateWiseTracks = {},
    EventSpeakers = [],
    Schedules = [],
    EventTags = [],
    SessionSpeakers = [],
    initialVal = {
      schedules: [],
    };

  if (
    !_.isEmpty(SessionColorsReducer) &&
    !_.isEmpty(SessionColorsReducer.payload) &&
    !_.isEmpty(ScheduleDataReducer) &&
    !_.isEmpty(ScheduleDataReducer.payload) &&
    !_.isEmpty(InterestsReducer) &&
    !_.isEmpty(state.checkinType)
  ) {
    // ----- Event tags
    // EventTags = InterestsReducer;
    _.map(InterestsReducer, (interest) => {
      EventTags.push({
        ...interest,
        id: interest.interestid,
        value: interest.interestid,
        label: interest.interest,
        name: interest.interest,
      });
    });

    // ----- Session colors
    SessionColors = SessionColorsReducer.payload;

    // ----- Schdule data
    ScheduleDataReducer = ScheduleDataReducer.payload;

    // ----- Speakers
    if (!_.isEmpty(ScheduleDataReducer.speaker_by_eventid)) {
      _.map(ScheduleDataReducer.speaker_by_eventid, (speaker) => {
        EventSpeakers.push({
          id: speaker.speakerid,
          value: speaker.speakerid,
          label: `${!_.isEmpty(speaker.firstname) ? speaker.firstname : ""}${
            !_.isEmpty(speaker.lastname) ? " " + speaker.lastname : ""
          }`,
          name: `${!_.isEmpty(speaker.firstname) ? speaker.firstname : ""}${
            !_.isEmpty(speaker.lastname) ? " " + speaker.lastname : ""
          }`,
        });
      });
    }

    // ----- Creating session_speakers array
    if (!_.isEmpty(ScheduleDataReducer.sessionspeakers_by_eventid))
      SessionSpeakers = ScheduleDataReducer.sessionspeakers_by_eventid;

    // ----- Creating date array
    if (!_.isEmpty(ScheduleDataReducer.scheduledates_by_eventid)) {
      _.map(ScheduleDataReducer.scheduledates_by_eventid, (date) => {
        // --- Accepting only active dates
        if (date.isactive) {
          // --- date formatted
          let scheduledate = `${date.scheduledate} 00:00:00`;
          let now = parse(
            moment(scheduledate).format("DD-MM-YYYY HH:mm:ss"),
            "dd-MM-yyyy HH:mm:ss",
            new Date()
          );
          let strDate = now.getDate() + " " + monthNames[now.getMonth()];

          let local_date = {
            id: date.scheduledateid,
            date: strDate,
            name: strDate,
            scheduledate: date.scheduledate,
            value: `${date.scheduledateid}`,
            tracks: [NO_TRACK_ITEM],
          };

          // --- tracks
          let trackData = date.ScheduleDateToScheduletracks;
          DateWiseTracks[date.scheduledate] = [NO_TRACK_ITEM];
          _.map(trackData, (track) => {
            let local_track = {
              dateid: track.scheduledateid,
              date: strDate,
              id: track.scheduletrackid,
              trackname: track.trackname,
              name: track.trackname,
              label: track.trackname,
              value: `${track.scheduletrackid}`,
            };

            local_date.tracks.push(local_track);
            DateWiseTracks[date.scheduledate].push(local_track);
          });

          ScheduleDates.push(local_date);
        }
      });
    }

    // ----- Creating sessions array
    if (!_.isEmpty(ScheduleDataReducer.session_by_eventid)) {
      _.map(ScheduleDataReducer.session_by_eventid, (schedule, index) => {
        // --- Deep cloning the prototype object
        let local_schedule = JSON.parse(JSON.stringify(ScheduleItem));

        local_schedule.id = schedule.sessionid; // session id
        local_schedule.title = schedule.title;
        local_schedule.description = schedule.description;
        local_schedule.location = schedule.location;
        local_schedule.liveurl = schedule.videolink;
        local_schedule.session_type = schedule.sessiontype;

        local_schedule.starttime = moment(schedule.starttime);
        local_schedule.endtime = moment(schedule.endtime);
        local_schedule.validtime = true;

        // date
        local_schedule.dateid = null; // schedule date id
        local_schedule.date = null; // formatted date string

        // track
        local_schedule.track = schedule.scheduletrackid; // track id
        local_schedule.trackname = null; // track name
        local_schedule.allow_track_select = true;

        // color
        local_schedule.colorid = schedule.colorid; // color id
        local_schedule.session_color = "#FFFFFF"; // default colour hex value

        // speaker
        local_schedule.speakerid = schedule.speakerid; // primary speaker, 0th index
        local_schedule.speaker = []; // detail objs
        local_schedule.speakers = ""; // comma separated speaker ids
        local_schedule.speaker_str = ""; // comma separated speaker names

        // checkin
        local_schedule.checkin_type = schedule.checkintype; // type value
        local_schedule.checkin_type_text = schedule.checkintype; // type name
        local_schedule.checkin_opt = state.checkinType;

        // eventtags
        local_schedule.event_tags = schedule.tags; // comma separated interest id from DB
        local_schedule.event_tags_str = schedule.tags; // tag name str

        // rsvp and capacity
        local_schedule.rsvp = schedule.rsvp;
        local_schedule.rsvp_text = schedule.rsvp
          ? LocaleStrings.button_yes
          : LocaleStrings.button_no;
        local_schedule.allow_capacity = schedule.rsvp;
        local_schedule.capacity = schedule.capacity;
        local_schedule.capacity_text =
          schedule.rsvp && schedule.capacity > 0
            ? schedule.capacity
            : LocaleStrings.unlimited;

        // --- date and track data extraction
        if (!_.isNull(schedule.scheduletrackid)) {
          _.map(DateWiseTracks, (date) => {
            let filteredTrack = _.filter(
              date,
              (track) => track.id === schedule.scheduletrackid
            );

            if (filteredTrack.length) {
              local_schedule.dateid = filteredTrack[0].dateid;
              local_schedule.date = filteredTrack[0].date;
              local_schedule.trackname = filteredTrack[0].trackname;
              local_schedule.allow_track_select =
                filteredTrack[0].trackname === "##NOTRACK##" ? false : true;
            }
          });
        }

        // --- session_color data extractiono
        if (!_.isNull(schedule.colorid)) {
          let filterColor = _.filter(
            SessionColors,
            (color) => color.colorid === schedule.colorid
          );

          if (filterColor.length) {
            local_schedule.session_color = filterColor[0].backgroundcolor;
          }
        }

        // --- speakers data extraction
        // - speaker data from session table speakerid
        let speakersNameArr = [],
          speakersIdArr = [];
        if (!_.isNull(schedule.speakerid)) {
          let filterSpeaker = _.filter(
            EventSpeakers,
            (speaker) => speaker.id == schedule.speakerid
          );

          if (filterSpeaker.length) {
            local_schedule.speaker.push(filterSpeaker[0]); // details pushed
            speakersNameArr.push(filterSpeaker[0].name); // name pushed
            speakersIdArr.push(filterSpeaker[0].id); // id pushed
          }
        }
        // - speaker data from sessionspeakers table
        let filterSessionSpeakers = [];
        if (!_.isEmpty(SessionSpeakers)) {
          // filterinng session_speakers as per selected session
          filterSessionSpeakers = _.filter(
            SessionSpeakers,
            (item) => item.sessionid == schedule.sessionid
          );

          // filtering speaker data as per filtered session_speaker
          filterSessionSpeakers.length &&
            _.map(filterSessionSpeakers, (speakerItem) => {
              let _filterSpeaker = _.filter(
                EventSpeakers,
                (speaker) => speaker.id == speakerItem.speakerid
              );

              if (
                _filterSpeaker.length &&
                !_.includes(local_schedule.speaker, _filterSpeaker[0])
              ) {
                local_schedule.speaker.push(_filterSpeaker[0]); // details pushed
                speakersNameArr.push(_filterSpeaker[0].name); // name pushed
                speakersIdArr.push(_filterSpeaker[0].id); // id pushed
              }
            });
        }
        // - speakers string update with all speakers
        local_schedule.speaker_str = _.join(speakersNameArr, ", ");
        local_schedule.speakers = _.join(speakersIdArr, ",");

        // --- Checkin type data extraction
        if (!_.isEmpty(schedule.checkintype)) {
          let filterCheckin = _.filter(
            state.checkinType,
            (type) => type.value == schedule.checkintype
          );

          if (filterCheckin.length) {
            local_schedule.checkin_type_text = filterCheckin[0].name;
          }
        }

        // --- Event tags (interests)
        if (!_.isEmpty(schedule.tags)) {
          let db_tags_arr = _.split(schedule.tags, ",");

          let local_tag_arr = [];
          _.map(db_tags_arr, (tagid) => {
            let tagData = _.filter(EventTags, (tag) => tag.interestid == tagid);

            if (tagData.length) local_tag_arr.push(tagData[0].interest);
          });
          local_schedule.event_tags_str = local_tag_arr.join(", ");
        }

        // --- final push to array
        Schedules.push(local_schedule);
        // initialVal.schedules.push(local_schedule);
      });

      // --- Sorting shcedules by starttime
      let _Schedules = _.sortBy(Schedules, (schedule) =>
        schedule.starttime.valueOf()
      );
      Schedules = _Schedules;
      initialVal.schedules = _Schedules;
    }
  }

  return {
    session: state.session,
    deviceSize: state.deviceSize,
    bulkEditModal: state.bulkEditModalControlReducer,
    ScheduleDataReducer: state.scheduleData,
    checkinType: state.checkinType,
    interestList: state.interests,
    selectedScheduleDate: state.selectedScheduleDate,

    SessionColors,
    ScheduleDates,
    DateWiseTracks,
    EventSpeakers,
    Schedules,
    EventTags,

    initialValues: initialVal,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  handleBulkEditModal,
  handleBulkEditUpdate,
  fetchAndRefreshScheduleData,
  createBulkTracks,
})(reduxForm({ form: "ScheduleBulkEditForm" })(ScheduleBulkEdit));

class BasicTableBody extends BaseComponent {
  // --- Reused component
  renderCustomAutoComplete = (field) => {
    // new customizaton added by udayan(06/09/22)
    let allinputval = field.input.value;
    let SelectedArrtObj = [];
    if (
      typeof allinputval === "string" &&
      allinputval !== "" &&
      _.size(field.options) > 0
    ) {
      let nameArr = allinputval.split(",");

      _.forEach(nameArr, (values) => {
        let obj = {};
        let filterValues = _.filter(
          field.options,
          (value) => value.id == values
        );

        // --- Slighly customized as required at Schedule Bulk Edit by Anubhab Mukherjee (26/04/23)
        if (filterValues && filterValues.length > 0) {
          obj.label = filterValues[0].label;
          obj.name = filterValues[0].name;
          obj.value = filterValues[0].value;
        }
        SelectedArrtObj.push(obj);
      });
      if (_.size(SelectedArrtObj) > 0) {
        field.input.value = SelectedArrtObj;
      }
    }

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass}`;

    return (
      <div className={divClassName}>
        <div
          className={`col-md-12 col-sm-12 col-sm-offset-0 d-flex wrapper-custom-addUser-basicDetails-category`}
        >
          <Select
            className={`react-multi-select-custom-css ${
              field.input.value ? "has-value" : ""
            }`}
            {...field.input}
            isMulti={field.isMulti ? true : false}
            value={field.input.value || ""}
            valueKey={field.valueKey}
            placeholder={field.placeholder}
            labelKey={field.labelKey}
            options={field.options}
            // onBlur={() => field.input.onBlur(field.input.value)}//commented by udayan for mobile issues
            isClearable
            maxMenuHeight={160}
            onBlur={(event) => {
              event.preventDefault();
            }}
          />
        </div>
        <div className="col-md-12 col-sm-12 col-sm-offset-0 text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  };

  render() {
    const {
      // props and states
      local_schedules,
      workingScheduleData,
      displayColorPicker,
      EventSpeakers,
      EventTags,
      renderInput,
      data_updated,

      // functions
      onChangeManager,
      handlePickerClickOpen,
      handlePickerClickClose,
      handleCellSelection,
      handleDeleteNewRow,
    } = this.props;

    console.log({ local_schedules, workingScheduleData });

    // --- Checkin types for sessions
    let checkinTypesOpts = [];
    _.forEach(this.props.checkinType, (value) => {
      var obj = {
        name: value.name,
        value: value.value,
      };

      checkinTypesOpts.push(obj);
    });

    // --- Session type options
    let sessionTypeOpts = [
      {
        label: LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_public,
        name: LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_public,
        value: "general",
      },
      {
        label: LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_private,
        name: LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_private,
        value: "private",
      },
    ];

    // --- Session-color picker
    let styles = reactCSS({
      default: {
        color: {
          width: "40px",
          height: "20px",
          border: "none",
          display: "flex",
          alignItems: "center",
        },
        swatch: {
          padding: "9px",
          background: "#fff",
          borderRadius: "5px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
          margin: "0px 5px 0px 0px",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
          boxShadow: "0 50px 60px 0 rgba(0,0,0,.1)",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    // --- Session colors
    let colorsArr = [];
    if (this.props.SessionColors && this.props.SessionColors.length > 0) {
      colorsArr = _.map(this.props.SessionColors, "backgroundcolor");
    }

    return (
      <>
        {_.map(workingScheduleData, (schedule, index) => {
          let isNewInsert = schedule.id == null ? true : false;

          // ----- Handling errors
          let errorsOfThisRow = _.filter(
            data_updated.errorCells,
            (error) => error.index === index
          );
          let errorTitle = "",
            errorTime = "";
          if (errorsOfThisRow.length) {
            errorTitle = _.filter(
              errorsOfThisRow,
              (error) => error.name === "title"
            );
            errorTime = _.filter(
              errorsOfThisRow,
              (error) => error.name === "time" // combined starttime & endtime
            );
          }

          return (
            <tr key={index}>
              {/* - Schedule index | Delete new insert - */}
              <td className="serial first-column">
                <div className="d-flex justify-content-center align-items-center">
                  {isNewInsert ? (
                    <>
                      <img
                        onClick={() => handleDeleteNewRow(index)}
                        className="h-75 p-1 cursor-pointer"
                        src={DeletTrashIcon}
                        alt="delete this new row"
                        style={{ maxHeight: 40 }}
                      />
                    </>
                  ) : (
                    index + 1
                  )}
                </div>
              </td>
              {/* - date | DD - */}
              <td
                tabIndex={index * 15 + 0 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "date"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "date")}
              >
                {renderInput.index === index && renderInput.name === "date" ? (
                  <>
                    <div className="field-container date">
                      <Field
                        name={`schedules[${index}].dateid`}
                        component={this.renderSelect}
                        opts={
                          !_.isEmpty(local_schedules)
                            ? local_schedules[index].dateOptons
                            : []
                        }
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data date center">
                      {schedule.date}
                    </div>
                  </>
                )}
              </td>
              {/* - track | DD - */}
              <td
                tabIndex={index * 15 + 1 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "track"
                    ? "selectedCell"
                    : ""
                } ${
                  schedule.allow_track_select
                    ? "cursor-pointer"
                    : "cursor-disbaled"
                }`}
                onFocus={() => handleCellSelection(index, "track")}
                style={
                  schedule.trackname === NO_TRACK
                    ? { backgroundColor: "var(--disabledcell-color)" }
                    : {}
                }
              >
                {schedule.allow_track_select ? (
                  renderInput.index === index &&
                  renderInput.name === "track" ? (
                    <>
                      <div className="field-container track">
                        <Field
                          name={`schedules[${index}].track`}
                          type="text"
                          component={this.renderCreateableSelect}
                          mandatory="true"
                          options={
                            !_.isEmpty(local_schedules)
                              ? local_schedules[index].trackOptions
                              : []
                          }
                          list="track"
                          maxlength={MAXLENOBJ.trackname ?? 1}
                          labelKey="label"
                          valueKey="value"
                          onChange={(data) =>
                            onChangeManager(
                              { target: { name: `schedules[${index}].track` } },
                              index,
                              data
                            )
                          }
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`field-container-data ${
                          isNewInsert && _.isEmpty(schedule.trackname)
                            ? "hasError"
                            : ""
                        } track text-truncate`}
                      >
                        {schedule.trackname === NO_TRACK
                          ? ""
                          : schedule.trackname}
                      </div>
                    </>
                  )
                ) : (
                  <></>
                )}
              </td>
              {/* - title - */}
              <td
                tabIndex={index * 15 + 2 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "title"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "title")}
              >
                {renderInput.index === index && renderInput.name === "title" ? (
                  <>
                    <div className="field-container title">
                      <Field
                        name={`schedules[${index}].title`}
                        component={this.renderFieldText}
                        type="text"
                        mandatory="true"
                        maxlength={MAXLENOBJ.title ? MAXLENOBJ.title : ""}
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={`field-container-data ${
                        errorTitle.length || _.isEmpty(schedule.title)
                          ? "hasError"
                          : ""
                      } title text-truncate`}
                    >
                      <div className="">{schedule.title}</div>
                    </div>
                  </>
                )}
              </td>
              {/* - location - */}
              <td
                tabIndex={index * 15 + 3 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "location"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "location")}
              >
                {renderInput.index === index &&
                renderInput.name === "location" ? (
                  <>
                    <div className="field-container location ">
                      <Field
                        name={`schedules[${index}].location`}
                        component={this.renderFieldText}
                        type="text"
                        mandatory="false"
                        maxlength={MAXLENOBJ.location ? MAXLENOBJ.location : ""}
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data location text-truncate">
                      {schedule.location}
                    </div>
                  </>
                )}
              </td>
              {/* - start time | Date picker - */}
              <td
                tabIndex={index * 15 + 4 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "starttime"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "starttime")}
              >
                {renderInput.index === index &&
                renderInput.name === "starttime" ? (
                  <>
                    <div className="field-container time">
                      <Field
                        name={`schedules[${index}].starttime`}
                        component={this.renderTimeInputMask}
                        selectedDate={
                          !_.isEmpty(local_schedules)
                            ? local_schedules[index].schedule_date
                            : ""
                        }
                        timeValue={schedule.starttime}
                        handleOnChange={(date) =>
                          onChangeManager(
                            {
                              target: {
                                name: `schedules[${index}].starttime`,
                              },
                            },
                            index,
                            date
                          )
                        }
                        selected={null}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={`field-container-data ${
                        errorTime.length ? "hasError" : ""
                      } time center`}
                    >
                      {schedule.starttime.format("HH:mm")}
                    </div>
                  </>
                )}
              </td>
              {/* - end time | Date picker - */}
              <td
                tabIndex={index * 15 + 5 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "endtime"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "endtime")}
              >
                {renderInput.index === index &&
                renderInput.name === "endtime" ? (
                  <>
                    <div className="field-container time">
                      <Field
                        name={`schedules[${index}].endtime`}
                        component={this.renderTimeInputMask}
                        selectedDate={
                          !_.isEmpty(local_schedules)
                            ? local_schedules[index].schedule_date
                            : ""
                        }
                        timeValue={schedule.endtime}
                        handleOnChange={(date) =>
                          onChangeManager(
                            {
                              target: {
                                name: `schedules[${index}].endtime`,
                              },
                            },
                            index,
                            date
                          )
                        }
                        selected={null}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className={`field-container-data ${
                        errorTime.length ? "hasError" : ""
                      } time center`}
                    >
                      {schedule.endtime.format("HH:mm")}
                    </div>
                  </>
                )}
              </td>
              {/* - description - */}
              <td
                tabIndex={index * 15 + 6 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "desc"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "desc")}
              >
                {renderInput.index === index && renderInput.name === "desc" ? (
                  <>
                    <div className="field-container desc">
                      <Field
                        name={`schedules[${index}].description`}
                        mandatory="false"
                        component={this.renderFieldTextarea}
                        maxlength={
                          MAXLENOBJ.description ? MAXLENOBJ.description : ""
                        }
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data desc text-truncate">
                      {schedule.description}
                    </div>
                  </>
                )}
              </td>
              {/* - speakers | custom select - */}
              <td
                tabIndex={index * 15 + 7 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "speakers"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "speakers")}
              >
                {renderInput.index === index &&
                renderInput.name === "speakers" ? (
                  <>
                    <div className="field-container speakers">
                      <Field
                        name={`schedules[${index}].speakers`}
                        component={this.renderCustomAutoComplete}
                        mandatory="false"
                        isMulti={true}
                        options={EventSpeakers}
                        labelKey="label"
                        valueKey="value"
                        onChange={(e) =>
                          onChangeManager(
                            {
                              target: {
                                name: `schedules[${index}].speakers`,
                              },
                            },
                            index,
                            e
                          )
                        }
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data speakers text-truncate">
                      {schedule.speaker_str}
                    </div>
                  </>
                )}
              </td>
              {/* - checkin | DD - */}
              <td
                tabIndex={index * 15 + 8 + 1}
                className={`${
                  renderInput.index == index &&
                  renderInput.name == "checkin_type"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "checkin_type")}
              >
                {renderInput.index === index &&
                renderInput.name === "checkin_type" ? (
                  <>
                    <div className="field-container checkin">
                      <Field
                        name={`schedules[${index}].checkin_type`}
                        component={this.renderSelect}
                        opts={checkinTypesOpts}
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data checkin text-truncate">
                      {schedule.checkin_type_text}
                    </div>
                  </>
                )}
              </td>
              {/* - session_color | Color picker */}
              <td
                tabIndex={index * 15 + 9 + 1}
                className={`${
                  renderInput.index == index &&
                  renderInput.name == "session_color"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "session_color")}
              >
                {renderInput.index === index &&
                renderInput.name === "session_color" ? (
                  <>
                    <div className="field-container sessioncolor">
                      <Field
                        name={`schedules[${index}].session_color`}
                        type="text"
                        mandatory="true"
                        component={this.renderCompactColorPickerField}
                        styles={styles}
                        onClick={() => handlePickerClickOpen(index)}
                        colorsArr={colorsArr}
                        displayColorPicker={
                          index === displayColorPicker.itemIndex &&
                          displayColorPicker.state
                        }
                        // value={schedule.session_color} // This needs to be checked why the input value data is not reflecting from second time selects
                        defaultValue={schedule.session_color}
                        handlePickerClose={handlePickerClickClose}
                        onChangeComplete={(color) =>
                          onChangeManager(
                            {
                              target: {
                                name: `schedules[${index}].session_color`,
                              },
                            },
                            index,
                            color
                          )
                        }
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data sessioncolor d-flex align-items-center">
                      <div
                        className="color-block"
                        style={{
                          backgroundColor: schedule.session_color,
                        }}
                      ></div>
                      <div className="">{schedule.session_color}</div>
                    </div>
                  </>
                )}
              </td>
              {/* - event_tags | custom select - */}
              <td
                tabIndex={index * 15 + 10 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "event_tags"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "event_tags")}
              >
                {renderInput.index === index &&
                renderInput.name === "event_tags" ? (
                  <>
                    <div className="field-container eventtags">
                      <Field
                        name={`schedules[${index}].event_tags`}
                        component={this.renderCustomAutoComplete}
                        mandatory="false"
                        isMulti={true}
                        options={EventTags}
                        labelKey="label"
                        valueKey="value"
                        onChange={(e) =>
                          onChangeManager(
                            {
                              target: {
                                name: `schedules[${index}].event_tags`,
                              },
                            },
                            index,
                            e
                          )
                        }
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data eventtags text-truncate">
                      {schedule.event_tags_str}
                    </div>
                  </>
                )}
              </td>
              {/* - session_type | DD - */}
              <td
                tabIndex={index * 15 + 11 + 1}
                className={`${
                  renderInput.index == index &&
                  renderInput.name == "session_type"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "session_type")}
              >
                {renderInput.index === index &&
                renderInput.name === "session_type" ? (
                  <>
                    <div className="field-container sessiontype">
                      <Field
                        name={`schedules[${index}].session_type`}
                        component={this.renderSelect}
                        opts={sessionTypeOpts}
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data checkin text-truncate">
                      {schedule.session_type == "general"
                        ? LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_public
                        : LocaleStrings.schedule_modal_bulkedit_sessiontype_opt_private}
                    </div>
                  </>
                )}
              </td>
              {/* - rsvp | Check box - */}
              <td
                tabIndex={index * 15 + 12 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "rsvp"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "rsvp")}
              >
                {renderInput.index === index && renderInput.name === "rsvp" ? (
                  <>
                    <div className="field-container rsvp">
                      <Field
                        name={`schedules[${index}].rsvp`}
                        component={this.renderFieldCheckbox}
                        type="checkbox"
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data rsvp text-truncate">
                      {schedule.rsvp_text}
                    </div>
                  </>
                )}
              </td>
              {/* - capacity | number - */}
              <td
                tabIndex={index * 15 + 13 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "capacity"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "capacity")}
              >
                {renderInput.index === index &&
                renderInput.name === "capacity" ? (
                  <>
                    <div className="field-container capacity">
                      <Field
                        name={`schedules[${index}].capacity`}
                        component={this.renderFieldText}
                        type="number"
                        min={"0"}
                        disabled={!schedule.allow_capacity}
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data capacity text-truncate">
                      {schedule.capacity_text}
                    </div>
                  </>
                )}
              </td>
              {/* - liveurl - */}
              <td
                tabIndex={index * 15 + 14 + 1}
                className={`${
                  renderInput.index == index && renderInput.name == "liveurl"
                    ? "selectedCell"
                    : ""
                } cursor-pointer`}
                onFocus={() => handleCellSelection(index, "liveurl")}
              >
                {renderInput.index === index &&
                renderInput.name === "liveurl" ? (
                  <>
                    <div className="field-container liveurl">
                      <Field
                        name={`schedules[${index}].liveurl`}
                        component={this.renderFieldText}
                        type="text"
                        onChange={(e) => onChangeManager(e, index)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="field-container-data liveurl text-truncate">
                      {schedule.liveurl}
                    </div>
                  </>
                )}
              </td>
            </tr>
          );
        })}
      </>
    );
  }
}
